import React, { useState } from "react";

type AppLogoProps = {
  src?: string | null;
  name?: string;
  frameClassName?: string;
  imageClassName?: string;
  placeholderClassName?: string;
};

// Shared by the auth forms (Login/Registration/Logout/ChangePassword/
// ResetPassword/Activation) so a missing or broken application logo always
// falls back to a letter placeholder instead of rendering nothing — matches
// the fallback already used independently on Home/Layout for the app grid
// and footer.
const AppLogo: React.FC<AppLogoProps> = ({ src, name, frameClassName, imageClassName, placeholderClassName }) => {
  const [failed, setFailed] = useState(false);
  const showPlaceholder = !src || failed;
  const initial = (name || "").trim().charAt(0).toLocaleUpperCase() || "?";

  return (
    <span className={frameClassName}>
      {showPlaceholder ? (
        <span className={placeholderClassName} aria-hidden="true">
          {initial}
        </span>
      ) : (
        <img
          className={imageClassName}
          src={src as string}
          alt={name || ""}
          decoding="async"
          loading="lazy"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
};

export default AppLogo;
